import {batch, computed, signal} from "@preact/signals-react";
import {NOTIFICATIONS_TYPE} from "../@constants";


export const repricingFormDataID = signal(null)
export const repricingFormDataOriginalName = signal('')
export const repricingFormData = signal({})
export const repricingActionRuleSelected = signal(NOTIFICATIONS_TYPE.REPRICING)
export const isLoadingRepricingFormChecker = signal(false)
export const repricingFormCheckerData = signal({})
export const repricingFormErrors = signal({})

// Computed
export const isRepricingFormEditing = computed(() => repricingFormDataID.value !== null)
export const disabledRepricing = computed(() => repricingActionRuleSelected.value === NOTIFICATIONS_TYPE.NOTIFICATION)
export const disabledEmail = computed(() => repricingActionRuleSelected.value === NOTIFICATIONS_TYPE.REPRICING)

// Functions
export const clearRepricingFormSignals = () => batch(() => {
	repricingFormDataID.value = null
	repricingFormDataOriginalName.value = ''
	repricingFormData.value = {}
	isLoadingRepricingFormChecker.value = false
	repricingFormCheckerData.value = {}
	repricingFormErrors.value = {}
})